var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.859 119.775C93.4694 119.775 119.905 93.3391 119.905 60.7286C119.905 28.1181 93.4694 1.68213 60.859 1.68213C28.2485 1.68213 1.8125 28.1181 1.8125 60.7286C1.8125 93.3391 28.2485 119.775 60.859 119.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4352 71.4641C98.4352 50.7117 81.6122 33.8887 60.8605 33.8887C40.1082 33.8887 23.2852 50.7117 23.2852 71.4641H34.0207C34.0207 56.6406 46.0371 44.6242 60.8598 44.6242C75.6826 44.6242 87.699 56.6406 87.699 71.4641",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5425 88.6417C74.8081 88.6417 83.9405 79.5092 83.9405 68.2437C83.9405 56.9782 74.8081 47.8457 63.5425 47.8457C52.277 47.8457 43.1445 56.9782 43.1445 68.2437C43.1445 79.5092 52.277 88.6417 63.5425 88.6417Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8595 82.7357C73.0142 82.7357 82.8675 72.8824 82.8675 60.7277C82.8675 48.573 73.0142 38.7197 60.8595 38.7197C48.7049 38.7197 38.8516 48.573 38.8516 60.7277C38.8516 72.8824 48.7049 82.7357 60.8595 82.7357Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.537 33.8889C99.7584 4.15611 63.6752 -7.96742 33.9417 6.81022C24.6706 11.4176 16.7466 18.3414 10.9375 26.9109L35.093 68.7806C30.645 54.6413 38.501 39.572 52.6403 35.1233C55.1272 34.3413 57.7148 33.9255 60.3215 33.8889",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9384 26.9116C-7.54947 54.492 -0.179671 91.8363 27.3993 110.326C35.9322 116.046 45.7886 119.484 56.0281 120.313L81.258 77.3708C71.8238 88.8053 54.9092 90.4258 43.4755 80.993C39.5918 77.7895 36.6874 73.5584 35.0939 68.7828",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0273 120.312C89.1357 122.815 118.005 98.0041 120.509 64.8956C121.317 54.2127 119.255 43.508 114.536 33.8896H60.3217C75.143 33.958 87.1052 46.0294 87.0368 60.8528C87.009 66.8498 84.9738 72.6646 81.2558 77.3701",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 26.9114L35.093 68.7812C33.3037 62.7594 33.6834 56.3007 36.166 50.53L12.0106 25.3008",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0269 120.312L81.2568 77.3696C77.2758 82.1162 71.7759 85.3401 65.6893 86.4945L54.9531 120.312",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.539 33.8887H60.3242C64.3556 33.9074 68.3309 34.8341 71.955 36.5998C75.5792 38.3655 78.759 40.9249 81.2584 44.088L115.612 35.5",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60.8334,
    y1: 38.7831,
    x2: 60.8334,
    y2: 82.7498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 62.7368,
    y1: 0.607896,
    x2: 62.7368,
    y2: 49.4564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.3772,
    y1: 103.462,
    x2: 40.0689,
    y2: 62.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#388B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CB749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 98.0929,
    y1: 107.801,
    x2: 71.7906,
    y2: 44.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FCD209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 23.5514,
    y1: 67.1705,
    x2: 23.5514,
    y2: 24.2284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 82.8245,
    y1: 81.0369,
    x2: 53.3023,
    y2: 111.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 82.3991,
    y1: 89.685,
    x2: 86.6934,
    y2: 47.2811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChrome);
export default __webpack_public_path__ + "static/media/logo-chrome.ff843e61fcf0e3bebfbeb6d662ad32ce.svg";
export { ForwardRef as ReactComponent };